export default {
  ...Object.fromEntries(
    ['NODE_ENV', 'VUE_APP_BASE_URL', 'VUE_APP_API_BASE_URL', 'STRIPE_TOKEN'].map((x) => [x, process.env[x]])
  )
}
